var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Auto Tint"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 10.6667C0.596954 10.6667 0 10.0697 0 9.33333C0 8.59695 0.596954 8 1.33333 8H30.6667C31.403 8 32 8.59695 32 9.33333C32 10.0697 31.403 10.6667 30.6667 10.6667H1.33333ZM0 18C0 18.7364 0.596954 19.3334 1.33333 19.3334H30.6667C31.403 19.3334 32 18.7364 32 18C32 17.2636 31.403 16.6667 30.6667 16.6667H1.33333C0.596954 16.6667 0 17.2636 0 18ZM0 26.6667C0 27.4031 0.596953 28 1.33333 28H30.6667C31.403 28 32 27.4031 32 26.6667C32 25.9303 31.403 25.3334 30.6667 25.3334H1.33333C0.596953 25.3334 0 25.9303 0 26.6667Z",
    fill: "#697D95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.a4dac251dc99ac8575428ca1568a76fc.svg";
export { ForwardRef as ReactComponent };